<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="修改" :visible.sync="visible" width="70%" :before-close="handleClose"
      destroy-on-close>
      <div>
        <el-form :model="form" :rules="rules" ref="roleForm" label-width="100px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="单图" prop="image">
            <Upload ref="upload" @change="uploadChange" :limit="1"></Upload>
          </el-form-item>
          <el-form-item label="多图" prop="images">
            <Upload ref="uploads" @change="uploadChanges" :limit="5"></Upload>
          </el-form-item>
          <el-form-item label="内容" prop="text">
            <wangEditor @change="editChange" v-model="form.text"></wangEditor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Upload from "@/components/upload/Upload"
  import wangEditor from "@/components/editor/wangEditor"
  export default {
    components: {
      Upload,
      wangEditor
    },
    props: {},
    data() {
      return {
        visible: false,
        loading: true,
        form: {
          id: "",
          title: '',
          image: '',
          images: '',
          sort: 0,
          text:'',
        },
        rules: {
          title: [{
            required: true,
            message: "标题不能为空",
            trigger: "blur"
          }],
        }
      }
    },
    created() {},
    methods: {
      editChange(data) {
        this.form.text = data;
      },
      uploadChange(data) {
        this.form.image = data;
      },
      uploadChanges(data) {
        this.form.images =(data);
      },
      submit() {
        this.$refs.roleForm.validate((valid) => {
          if (valid) {
            this.$request({
              url: this.$api.test.update,
              method: "post",
              data: this.form
            }).then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.$emit("ok");
                this.visible = false
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch(() => {
              this.$message.error("请求失败")
            })
          } else {
            return false;
          }
        })
      },
      handleClose() {
        this.$refs.upload.clearFiles();
        this.$refs.uploads.clearFiles();
        this.visible = false
      },
      getData(val) {
        this.form = {
          ...val
        }
        setTimeout(() => {
          this.$refs.upload.setFiles([this.form.image])
          this.$refs.uploads.setFiles(((this.form.images)))
        }, 100)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/test/editModal.vue